var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none-wapper"},[_c('span',[_vm._v(_vm._s(_vm.$t("未检测到账户")))]),_c('el-button',{staticClass:"button_blue",on:{"click":_vm.setting}},[_vm._v(_vm._s(_vm.$t("去设置")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }